import React from 'react';
import { LightbulbIcon } from 'lucide-react';
import { TopBanner } from '../components/TopBanner';
import { ParticipantTestimonials } from '../components/ParticipantTestimonials';
import { ExpertProfile } from '../components/ExpertProfile';
import { WebinarTimeline } from '../components/WebinarTimeline';
import { WebinarDetailsCard } from '../components/WebinarDetailsCard';
import { BonusSection } from '../components/BonusSection';
import { TrustpilotReviews } from '../components/TrustpilotReviews';
import { WhyDifferent } from '../components/WhyDifferent';
import { FAQSections } from '../components/FAQSections';
import { TransformationSummary } from '../components/TransformationSummary';
import { FinalCTA } from '../components/FinalCTA';
import { ChatTestimonials } from '../components/ChatTestimonials';
import { NewFooter } from '../components/NewFooter';
import { StickyBar } from '../components/StickyBar';
import { RegistrationProvider, useRegistration } from '../components/RegistrationContext';
const Adv2bContent = () => {
  const {
    openPopup
  } = useRegistration();
  return <>
      <div className="advertorial-content max-w-3xl mx-auto px-4 font-sans text-gray-800 pb-28" data-id="element-594" data-mp="bwouat5846wi">
        <TopBanner data-id="element-595" data-mp="3td6ou2oy7iqg" />

        {/* 1. HOOFDTITEL (Hero sectie aangepast) */}
        <section className="mb-10 text-center" data-id="element-596" data-mp="3tau6vpj6x8de">
          <h1 className="text-[1.6rem] md:text-3xl font-bold text-[rgb(30,64,175)] mb-6 text-center leading-snug" data-id="element-597" data-mp="25c4e72zjqt4">
            Waarom jouw hond niet luistert - en waarom jij daar zelf de oorzaak
            van bent
          </h1>
          <p className="text-blue-600 font-semibold mb-8 text-center" data-id="element-598" data-mp="3obhbuhi60uzq">
            Modern onderzoek naar honden laat zien dat we op een andere manier
            met hen om moeten gaan.
          </p>
          <div className="w-full mb-2" data-id="element-599" data-mp="3fezzxc1z8t2x">
            <img src="https://cdn.magicpatterns.com/uploads/t8jaMNfJ3z6DxQ27njofF8/Scherm_afbeelding_2025-08-21_om_23.44.08-min_(1).png" alt="Labrador aan de lijn op straat" className="w-full h-auto rounded-lg" data-id="element-600" data-mp="18lxwg6tz3zzo" />
          </div>
          <p className="text-xs text-gray-400 italic mb-6" data-id="element-601" data-mp="175abbhtes5lr">
            Soms kan anderhalf uur alles veranderen in de relatie met je hond
          </p>
          <div className="w-full h-[1px] bg-gray-200" data-id="element-602" data-mp="126pl8b7vf2b1"></div>
        </section>

        {/* 2. EERSTE TEKSTBLOK (Vervangt LisaStory) */}
        <section className="mb-12" data-id="element-603" data-mp="x9h1w7azks87">
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-604" data-mp="1uv4ndx5wlq4y">
            Je hond springt op als er bezoek komt. Of hij blaft aan één stuk
            door. Of hij trekt zo hard aan de lijn dat wandelen geen plezier
            meer is. Je hebt het al tientallen keren gecorrigeerd. Je bent
            strenger geworden. Je hebt je stem verheven. Misschien heb je hem
            zelfs bestraft.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-605" data-mp="2dme6my5h7t9q">
            En toch gebeurt het steeds weer.
          </p>
          <p className="mb-8 text-gray-800 leading-relaxed" data-id="element-606" data-mp="28t30z0cehije">
            Wat de meeste baasjes op dat moment denken: mijn hond wil gewoon
            niet luisteren. Maar volgens gediplomeerd hondengedragsconsultant
            Amee de Bruijn is wat er in werkelijkheid aan de hand is, iets heel
            anders.
          </p>
          <div className="w-full mb-6" data-id="element-607" data-mp="2q6b69aue04ry">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3JyaDPTDobRjD5WRihmtQh/Scherm%C2%ADafbeelding_2025-08-15_om_15.32.12.png" alt="Innig moment tussen een man en zijn golden retriever die elkaar aandachtig aankijken" className="w-full h-auto rounded-lg" data-id="element-608" data-mp="2v3bb5ifi31hh" />
            <p className="text-xs text-gray-500 mt-2 text-center italic" data-id="element-609" data-mp="38uzlpha3phwc">
              Het moment waarop je eindelijk begrijpt wat je hond al die tijd
              probeerde te zeggen
            </p>
          </div>
        </section>

        {/* 3. TWEEDE TEKSTBLOK (Vervangt BreakthroughMoment) */}
        <section className="mb-12" data-id="element-610" data-mp="3nrys51t7v4p8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-611" data-mp="odpu4420i3hb">
            Je praat heel de dag met lichamelijke signalen
          </h2>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-612" data-mp="jdlbo8hjmyog">
            "Honden communiceren primair via lichaamstaal," legt Amee uit.
            "Blaffen en piepen zijn eigenlijk al de laatste uitingen - het punt
            waarop een hond niet meer weet hoe hij het anders moet zeggen."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-613" data-mp="5fn3xlxqa0hx">
            De echte communicatie zit volgens haar in veel subtielere signalen.
            Een hond die gaapte toen je hem aanraakte. Een hond die zijn gewicht
            verplaatste toen je dichter bij hem kwam. Een hond die even wegkeek
            op het moment dat de spanning opliep. Geen toevallige bewegingen,
            zegt Amee - boodschappen.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-614" data-mp="1pwrxsb2l8ji7">
            Maar de meeste baasjes weten niet wat ze betekenen. "Niet omdat ze
            het niet willen weten," benadrukt ze, "maar omdat niemand het ze
            ooit heeft geleerd. Je wordt niet geboren met kennis van hondentaal.
            En in de meeste traditionele hondentrainingen staat het ook niet
            centraal."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-615" data-mp="1odjmvvf01zmw">
            Het gevolg is dat baasjes de hele aanloop missen. Ze zien niet wat
            er opbouwt. Ze zien alleen het eindpunt - het blaffen, het springen,
            het uitvallen - en dát is het moment waarop ze ingrijpen. Met een
            correctie. Met straf.
          </p>
          <p className="mb-6 text-gray-800 leading-relaxed font-semibold" data-id="element-616" data-mp="22c9hn4ecjn83">
            "Maar tegen de tijd dat een hond zover is," zegt Amee, "heeft hij al
            lang geprobeerd iets te zeggen. En niemand heeft geluisterd."
          </p>
        </section>

        {/* 4. DERDE TEKSTBLOK */}
        <section className="mb-12" data-id="element-617" data-mp="2ztqd43dc2d54">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-618" data-mp="2zursul5annt6">
            Je stem zegt: Stop daarmee. Maar je lichaam zegt: ik keur dit goed.
          </h2>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-619" data-mp="34qngv7nr1r5g">
            Voor veel baasjes is dit het moment waarop alles op zijn plaats
            valt. Want het probleem is niet alleen dat baasjes hondentaal niet
            begrijpen - het probleem is ook dat baasjes zelf voortdurend
            signalen afgeven waar ze zich niet bewust van zijn.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-620" data-mp="2lzcqcrlxrge3">
            Amee legt tijdens haar webinar{' '}
            <a href="/webinar-mc-adv2" onClick={e => {
            e.preventDefault();
            openPopup();
          }} className="text-blue-700 underline font-semibold cursor-pointer hover:text-blue-900" data-id="element-621" data-mp="2gzi26vtjp4wq">
              (klik hier om beschikbaarheid te zien)
            </a>{' '}
            een veelvoorkomende situatie uit: je hond springt op. Jij wordt
            boos. Je verheft je stem, je zegt streng "nee" of "af". Maar
            tegelijkertijd zeg je met je lichaam dat je zijn gedrag goedkeurt.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed italic font-semibold" data-id="element-622" data-mp="sgncj91l6yw8">
            "Jouw stem zegt: stop daarmee. Jouw lichaam zegt: ik keur dit goed."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-623" data-mp="wfmnbaa01pvl">
            En honden kijken meer naar lichaamstaal dan naar stemgeluid. "Dus
            wat denk je welk signaal er aankomt?" vraagt Amee.
          </p>
          <p className="mb-6 text-gray-800 leading-relaxed" data-id="element-624" data-mp="8smuwk8p1m4r">
            Dit is slechts één voorbeeld. Amee beschrijft tientallen situaties
            per dag waarin hetzelfde gebeurt - waarin de bedoeling van de
            eigenaar en zijn lichaamstaal elkaar tegenspreken. En elke keer
            raakt de hond een stukje meer verward.
          </p>
        </section>

        {/* 5. VIERDE TEKSTBLOK */}
        <section className="mb-12" data-id="element-625" data-mp="2akcczocuu36d">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-626" data-mp="2aldyynvesa2v">
            De oplossing is eenvoudiger dan je denkt
          </h2>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-627" data-mp="25o5gem6cm413">
            "Hondentaal is geen mysterie," stelt Amee. "Het is een consistent
            systeem van signalen dat te leren is."
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed" data-id="element-628" data-mp="2tjq9oe1yxs0k">
            En zodra je het kent, gebeuren er volgens haar twee dingen tegelijk.
            Je begrijpt eindelijk wat je hond al die tijd probeerde te
            vertellen. En je leert hoe je zelf bewuster communiceert - met je
            lichaam, niet alleen met je stem.
          </p>
          <p className="mb-4 text-gray-800 leading-relaxed italic font-semibold" data-id="element-629" data-mp="2ybrifpzxh0lu">
            "Dat is het moment waarop het gedrag verandert. Niet omdat de hond
            anders wordt, maar omdat de communicatie eindelijk klopt."
          </p>
          <p className="mb-6 text-gray-800 leading-relaxed" data-id="element-630" data-mp="3qwwxm8a0semi">
            De verwarring verdwijnt. En daarmee verdwijnt ook het gedrag dat
            zoveel frustratie veroorzaakte.
          </p>
        </section>

        {/* 6. SECTIE MET HET GEKLEURDE KADER */}
        <section className="mb-12" data-id="element-631" data-mp="3hvqcflwfefmx">
          <div className="bg-blue-50 border-l-4 border-blue-700 rounded-r-lg p-8" data-id="element-632" data-mp="3mvbdc1v5oy2a">
            <div className="flex items-center gap-3 mb-6" data-id="element-633" data-mp="3mxfnv2nk8vbj">
              <LightbulbIcon className="w-6 h-6 text-blue-700" data-id="element-634" data-mp="385dt1x0cksid" />
              <h2 className="text-2xl font-bold text-blue-900" data-id="element-635" data-mp="3cwvmm001jqtb">
                Leer hondentaal in 90 minuten - gratis
              </h2>
            </div>

            <p className="mb-4 text-gray-800 leading-relaxed text-lg" data-id="element-636" data-mp="2z7lg2zi3lwy5">
              Amee de Bruijn deelt deze kennis in{' '}
              <a href="/webinar-mc-adv2" onClick={e => {
              e.preventDefault();
              openPopup();
            }} className="text-blue-700 underline font-semibold cursor-pointer hover:text-blue-900" data-id="element-637" data-mp="2p7ks309aasnm">
                een gratis webinar van 90 minuten
              </a>{' '}
              voor hondeneigenaren die vastlopen met hun hond. Je leert welke
              signalen je hond gebruikt en wat ze betekenen. Je leert hoe je die
              signalen eerder herkent - voordat gedrag escaleert. En je leert
              hoe je je eigen lichaamstaal bewust inzet, zodat jouw boodschap
              ook daadwerkelijk aankomt.
            </p>

            <p className="text-blue-800 leading-relaxed text-lg font-semibold mb-4" data-id="element-638" data-mp="10do6ajd8bujt">
              Meer dan 100.000 Nederlandse en Vlaamse hondeneigenaren volgden
              het webinar al. Veel van hen zeiden achteraf hetzelfde: het was
              alsof er eindelijk ondertiteling werd aangezet.
            </p>

            <p className="text-gray-800 leading-relaxed text-lg mb-6" data-id="element-639" data-mp="1ecw8zm8lpksr">
              Meld je gratis aan. Eén webinar van 90 minuten kan veranderen hoe
              jij en je hond de rest van jullie leven met elkaar communiceren.
            </p>

            <button onClick={openPopup} className="w-full bg-[#22c55e] hover:bg-[#16a34a] text-white font-bold py-4 px-8 rounded-lg text-lg transition-colors duration-200 shadow-lg" data-id="element-640" data-mp="2ywjbri3ulyjr">
              Bekijk webinar van Amee →
            </button>
          </div>

          <div className="w-full mt-6 mb-6" data-id="element-641" data-mp="2kwgu9wzgd751">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mPezTbx7aSGaxHbt8eLB8F/Scherm%C2%ADafbeelding_2025-08-15_om_15.37.25.png" alt="Vrouw in oranje trui communiceert met haar border collie in een park" className="w-full h-auto rounded-lg" data-id="element-642" data-mp="2kxjmq9cfbhn2" />
            <p className="text-xs text-gray-500 mt-2 text-center italic" data-id="element-643" data-mp="2ox0puw4do2p2">
              "In 90 minuten kan ik mensen de basisgrammatica van de hondentaal
              leren," stelt Amee
            </p>
          </div>
        </section>

        {/* AL HET ANDERE (Blijft exact hetzelfde) */}
        <ParticipantTestimonials data-id="element-644" data-mp="2xzks4teadclr" />

        {/* Wat is een webinar? (inline, vervangt Science component) */}
        <section className="mb-12" data-id="element-645" data-mp="32xckfoiuf0qh">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-646" data-mp="3710r84znhsao">
            Wat is een webinar?
          </h2>
          <p className="text-gray-800 leading-relaxed" data-id="element-647" data-mp="3c0do7ik8kfqz">
            Een webinar is een online presentatie die je live kunt volgen vanaf
            je telefoon, tablet of computer. Je hoeft nergens naartoe te reizen
            - je volgt gewoon thuis, op kantoor of onderweg via een
            internetverbinding. Tijdens het webinar kun je via de chat vragen
            stellen aan Amee, en na afloop ontvang je automatisch de opname
            zodat je alles terug kunt kijken wanneer het jou uitkomt.
          </p>
        </section>

        <ExpertProfile data-id="element-648" data-mp="1vl2o0hr5m0hd" />
        <WebinarTimeline data-id="element-649" data-mp="1vjrlel9g2yru" />
        <WebinarDetailsCard data-id="element-650" data-mp="20kf84uqn4tg9" />
        <BonusSection data-id="element-651" data-mp="20jdz0vt6qh16" />
        <TrustpilotReviews data-id="element-652" data-mp="20ivvrf83v2jr" />
        <WhyDifferent data-id="element-653" data-mp="1t15z52m1qwrq" />
        <FAQSections data-id="element-654" data-mp="1t1fsn06avm26" />
        <TransformationSummary data-id="element-655" data-mp="1szuz9dvq295w" />
        <FinalCTA data-id="element-656" data-mp="1sz3aalwmr9ol" />
        <ChatTestimonials data-id="element-657" data-mp="1o2348azs66xh" />
        <NewFooter data-id="element-658" data-mp="1o1tcahv6dpp5" />
      </div>
      <StickyBar data-id="element-659" data-mp="1o2w4qu85c076" />
    </>;
};
export const Adv2bPage = () => {
  return <RegistrationProvider data-id="element-660" data-mp="1j1yqgsq9bqay">
      <Adv2bContent data-id="element-661" data-mp="1j16u3fou5ojm" />
    </RegistrationProvider>;
};